import { Status } from '@/models/Status';
import { Supplier } from '@/models/Supplier';

export interface ProductCategory {
  id: string;
  name: string;
  description: string;
  status: Status;
  parentId?: string;
  level?: number;
  left?: number;
  right?: number;
  supplier?: Supplier;
  supplierId: string;
  externalCode?: string;
  createdAt: Date;
}

export interface ProductCategories {
  items: ProductCategory[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export enum ProductCategoryAssociation {
  SUPPLIER = 'supplier',
  ALL = 'all',
}

export interface ProductCategoryCreate {
  name: string;
  description: string;
  status: Status;
  parentId?: string;
  externalCode?: string;
  supplierId?: string;
}

export interface ProductCategoryUpdate {
  id: string;
  name: string;
  description: string;
  status: Status;
  parentId?: string;
  externalCode?: string;
  supplierId?: string;
}
